import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {
    BlockSpacer,
    currentMedia,
    GridContainer,
    GridItem
} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY, PET_TYPE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../helper/NatPetBreedingApplyHelper'
import {DisplayItemLabelDiv} from '../../../../../styledComponents/DisplayItem'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {StyledImg} from '../../../../../styledComponents/StyledTypeDefinitions'
import {ImageInformation} from '../../../../../components/shared/forms/resident/PPImageInputWithPreviewForResident'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    petType: Nullable<string>
    petBreed: Nullable<string>
    havePetStartMonth: Nullable<string>
    healthCenterDogLicense: Nullable<ImageInformation>
    rabiesPreventionInjectionCertification: Nullable<ImageInformation>
    applyFlag?: boolean
}

const NatResidentPetBreedingApplyConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, petType, petBreed,
        havePetStartMonth, healthCenterDogLicense, rabiesPreventionInjectionCertification
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.BREEDING_PETS_APPLY.label
    const havePetStartMonthLabel = (havePetStartMonth) ?
        getFormattedDate(havePetStartMonth) : ''

    const petTypeLabel = (petType) ?
        PET_TYPE.codeToEnumConstants(petType).label : ''

    const petBreedLabel = petBreed ?? ''

    const extensionDogLicense = healthCenterDogLicense?.fileName ?? ''

    const extensionRabies = rabiesPreventionInjectionCertification?.fileName ?? ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        <NatResidentApplicationDetailConfirmItem
            title={'種類'}
            items={[petTypeLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'品種'}
            items={[petBreedLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'飼育開始月'}
            items={[havePetStartMonthLabel]}
        />
        {(petType === PET_TYPE.DOG.value && healthCenterDogLicense) ?
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>保健所犬鑑札</Box></DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            <ImageDiv>
                                <Image
                                    src={String(healthCenterDogLicense.fileData ?
                                        'data:image/' + extensionDogLicense.split('.').pop() +
                                        ';base64,' + healthCenterDogLicense.fileData
                                        : healthCenterDogLicense.path
                                    )}
                                    alt={String(extensionDogLicense)}
                                />
                            </ImageDiv>
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </> : null
        }

        {(petType === PET_TYPE.DOG.value && rabiesPreventionInjectionCertification) ?
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>狂犬病予防注射済証</Box></DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            <ImageDiv>
                                <Image
                                    src={String(rabiesPreventionInjectionCertification.fileData ?
                                        'data:image/' + extensionRabies.split('.').pop() +
                                        ';base64,' + rabiesPreventionInjectionCertification.fileData
                                        : rabiesPreventionInjectionCertification.path
                                    )}
                                    alt={String(extensionRabies)}
                                />
                            </ImageDiv>
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </> : null
        }
    </>)
}

NatResidentPetBreedingApplyConfirm.displayName = 'NatResidentPetBreedingApplyConfirm'
export default NatResidentPetBreedingApplyConfirm

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
 ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`
const Image: StyledImg = styled.img`
  max-width: 253px;
  max-height: 168px;
`
const ImageDiv = styled.div`
 ${currentMedia.lessThan('sp')`
    text-align:center;
  `}
`